<template>
  <div class="container-fluid u-padding-0">
    <div v-if="getBatteryLoadingById || !batteryIsLoaded" class="o-card">
      <loading></loading>
    </div>
    <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
    <div class="o-card" v-else-if="!batteryItem">
      <LockedView>
        <div>
          {{ $t("batteryDetail.notFound") }}
        </div>
        <div class="u-margin-top">
          <router-link :to="{ name: 'batteries' }">
            <Button variant="primary">
              <i class="icofont-arrow-left"></i> {{ $t("common.back") }}
            </Button>
          </router-link>
        </div>
      </LockedView>
    </div>
    <div class="row row-no-gutters" v-else>
      <div
        class="es-xs-12 col-sticky u-top-0 u-padding-bottom-xsmall es-lg-8 es-xl-9"
      >
        <div>
          <div class="row u-margin-left-0 u-margin-right-0">
            <div
              v-if="!batteryItem.isActive"
              class="es-xs-12 u-padding-bottom-xsmall"
            >
              <IsOldLogBar
                @refresh="GET_BATTERY(true)"
                :battery="batteryItem"
              ></IsOldLogBar>
              <IsLockedBattery
                v-if="batteryItem.isLocked"
                :battery="batteryItem"
              ></IsLockedBattery>
            </div>
            <div
              class="es-xs-12 u-padding-bottom-xsmall u-padding-left-0 u-padding-0 es-lg-12"
            >
              <BatteryInfo :battery="batteryItem"></BatteryInfo>
            </div>
            <div class="es-xs-12 u-padding-bottom-xsmall">
              <BatteryTabs
                :battery="batteryItem"
                :features="batteryFeatures"
                :result="batteryResultFeatures"
              ></BatteryTabs>
            </div>
          </div>
        </div>
      </div>
      <div
        class="es-xs-12 es-lg-4 es-xl-3 u-padding-bottom-xsmall u-padding-left-xsmall"
      >
        <ActionBar
          @refresh="GET_BATTERY(true)"
          class="u-margin-bottom-small"
          :battery="batteryItem"
        ></ActionBar>
        <BatteryProjects :battery="batteryItem" />
        <img src="@/assets/images/coil.jpg" width="100%" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import BatteryInfo from "./BatteryInfo.vue";
import ActionBar from "./ActionBar.vue";
import BatteryTabs from "./Tabs/BatteryTabs.vue";
import IsOldLogBar from "./IsOldLogBar.vue";
import LockedView from "../LockedView/index.vue";
import Loading from "../Base/Loading/Loading.vue";
import batteryMixin from "@/mixins/batteryMixin";
import Button from "../Base/Button.vue";
import IsLockedBattery from "./IsLockedBattery.vue";
import authorize from "../Batteries/authorize";
import BatteryProjects from "./Tabs/BatteryProjects.vue";
export default {
  components: {
    BatteryProjects,
    BatteryInfo,
    LockedView,
    ActionBar,
    BatteryTabs,
    IsOldLogBar,
    Loading,
    Button,
    IsLockedBattery,
  },
  mixins: [authorize, batteryMixin],
  data() {
    return {
      batteryId: null,
    };
  },
  created() {
    this.batteryId = Number(this.$route.params.id);
    // devamını mixin yapıyor.
  },
};
</script>

<style></style>
